import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {RightSidebarActionButton} from "../../../layout/rightSidebar/RightSidebarRail";
import {ServerTablePrintDialog} from "../print/ServerTablePrintDialog";
import {useServerTableContext} from "../ServerTableContext";
import type {ServerTablePrintProps} from "../types";

export function ServerTableRailPrint({
    title,
    selectedDate,
    initialOrientation,
    disabled,
}: ServerTablePrintProps) {
    const {t} = useTranslation();
    const {table, query, printRows} = useServerTableContext();
    const [open, setOpen] = useState(false);
    const isDisabled = disabled || query.isLoading || query.isError || query.isPreviousData;

    return (
        <>
            <RightSidebarActionButton
                icon={<PrintOutlinedIcon/>}
                label={t("Print")}
                disabled={isDisabled}
                onClick={() => setOpen(true)}
            />

            <ServerTablePrintDialog
                open={open}
                onClose={() => setOpen(false)}
                table={table}
                title={title}
                selectedDate={selectedDate}
                initialOrientation={initialOrientation}
                printRows={printRows}
            />
        </>
    );
}
